import { getCountries, getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js';

let cache = null;

export function getAllPhoneCountries() {
  if (cache) return cache;

  let displayNames;
  try {
    displayNames = new Intl.DisplayNames(['pt-BR'], { type: 'region' });
  } catch (e) {
    displayNames = null;
  }

  cache = getCountries()
    .map((code) => {
      const dial = `+${getCountryCallingCode(code)}`;
      const name = displayNames ? displayNames.of(code) : code;
      return {
        code, dial, name, label: `${dial} (${name})`,
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));

  return cache;
}

export function getDefaultPhoneCountry(language) {
  return language === 'pt' ? 'PT' : 'BR';
}

/**
 * Splits a stored telephone string back into { countryCode, phone } so it can be
 * loaded into a CountryCodeSelect + AsYouType-formatted field without showing the
 * DDI twice. Handles the current "+DDI national number" format for any country,
 * plus legacy records saved before the country select existed (raw Brazilian
 * numbers with no DDI, and the old Portugal mask that baked "+351" into the field).
 */
export function parsePhoneValueFull(value, fallbackCountry = 'BR') {
  if (!value) {
    return { countryCode: fallbackCountry, phone: '' };
  }
  const trimmed = value.trim();
  const parsed = parsePhoneNumberFromString(trimmed);
  if (parsed && parsed.country) {
    return { countryCode: parsed.country, phone: parsed.formatNational() };
  }
  return { countryCode: fallbackCountry, phone: trimmed };
}
